var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinner = function SvgSpinner(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.939,
    height: 4.364,
    x: 7.031,
    fill: "#fff",
    rx: 0.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M12.285 2.343a.97.97 0 1 1 1.372 1.372l-1.714 1.714a.97.97 0 0 1-1.372-1.372z",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.939,
    height: 4.364,
    x: 16,
    y: 7.03,
    fill: "#fff",
    fillOpacity: 0.4,
    rx: 0.97,
    transform: "rotate(90 16 7.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M13.657 12.286a.97.97 0 0 1-1.372 1.37l-1.714-1.713a.97.97 0 0 1 1.371-1.372z",
    clipRule: "evenodd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.939,
    height: 4.364,
    x: 8.969,
    y: 16,
    fill: "#fff",
    fillOpacity: 0.6,
    rx: 0.97,
    transform: "rotate(180 8.97 16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    fillRule: "evenodd",
    d: "M3.715 13.657a.97.97 0 0 1-1.372-1.371l1.714-1.715a.97.97 0 1 1 1.372 1.372z",
    clipRule: "evenodd"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.939,
    height: 4.364,
    y: 8.97,
    fill: "#fff",
    fillOpacity: 0.8,
    rx: 0.97,
    transform: "rotate(-90 0 8.97)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.939,
    height: 4.364,
    x: 1.658,
    y: 3.029,
    fill: "#fff",
    fillOpacity: 0.9,
    rx: 0.97,
    transform: "rotate(-45 1.658 3.029)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export { ForwardRef as ReactComponent };